import { SECURITY_EVENTS, EVENT_SEVERITY } from './constants';
import { isAllowCopyTarget } from './securityPolicy';

export function subscribeClipboardGuard(logSecurityEvent, policy) {
  if (typeof document === 'undefined') return () => {};

  const onContext = (event) => {
    if (!policy.blockContextMenu) return;
    event.preventDefault();
    logSecurityEvent({
      type: SECURITY_EVENTS.CONTEXT_MENU_ATTEMPT,
      severity: EVENT_SEVERITY[SECURITY_EVENTS.CONTEXT_MENU_ATTEMPT],
      message: 'Candidate attempted to open context menu'
    });
  };

  const makeHandler = (type, block, message) => (event) => {
    if (!block) return;
    if (isAllowCopyTarget(event.target)) return;
    event.preventDefault();
    logSecurityEvent({
      type,
      severity: EVENT_SEVERITY[type],
      message
    });
  };

  const onCopy = makeHandler(SECURITY_EVENTS.COPY_ATTEMPT, policy.blockCopy, 'Candidate attempted to copy exam content');
  const onCut = makeHandler(SECURITY_EVENTS.CUT_ATTEMPT, policy.blockCut, 'Candidate attempted to cut exam content');
  const onPaste = makeHandler(SECURITY_EVENTS.PASTE_ATTEMPT, policy.blockPaste, 'Candidate attempted to paste into the exam');

  document.addEventListener('contextmenu', onContext);
  document.addEventListener('copy', onCopy);
  document.addEventListener('cut', onCut);
  document.addEventListener('paste', onPaste);

  return () => {
    document.removeEventListener('contextmenu', onContext);
    document.removeEventListener('copy', onCopy);
    document.removeEventListener('cut', onCut);
    document.removeEventListener('paste', onPaste);
  };
}
